import i18n from '@/lang/i18n'
import { UserType, UserTypeTranslationKeys } from '@/api/resources/common/initialization/common-initialization.dto.ts'
import { getEnumTranslationKeyColumnGridOptions } from '@/grid/base-grid-options'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.name'),
            field: 'name',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.code'),
            field: 'code',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.description'),
            field: 'description',
            flex: 1
        },
        {
            ...getEnumTranslationKeyColumnGridOptions(UserTypeTranslationKeys, 'code', 'translationKey'),
            headerName: i18n.tc('configuration.grid.userType'),
            type: AgGridColumnType.TEXT,
            colId: 'userType',
            field: 'userType.translationKey',
            minWidth: 190,
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.system'),
            field: 'isSystemRole',
            flex: 1
        }
    ]
}
